
export function fullReconCbrMinimum(project) {
  if (project.existingSubgradeCbrUnderThreshold){
    return {
      title: "CBR Minimum",
      message:
        "Reconstruction is a viable treatment option, but RxPave recommends that you first ensure the subgrade be strengthened to a CBR of at least 10."
    };
  }
}
